// EAKC Architecture Video — Design Tokens & Timing

// === Colors ===
export const COLORS = {
  // Background
  bg: "#0A0E1A",
  bgLight: "#111827",
  bgCard: "#1A1F35",
  bgCardHover: "#232945",

  // Accent gradients
  accentBlue: "#86A8E7",
  accentPurple: "#7F5AF0",
  accentTeal: "#2DD4BF",
  accentPink: "#F472B6",
  accentOrange: "#FB923C",
  accentGreen: "#34D399",
  accentRed: "#EF4444",
  accentYellow: "#FBBF24",

  // Text
  textPrimary: "#F1F5F9",
  textSecondary: "#94A3B8",
  textMuted: "#64748B",

  // Borders
  border: "#1E293B",
  borderLight: "#334155",

  // Layer colors (for architecture diagram)
  layerClient: "#3B82F6",
  layerApp: "#8B5CF6",
  layerCore: "#7F5AF0",
  layerData: "#2DD4BF",
  layerExternal: "#FB923C",

  // Source integrations
  github: "#F0F6FC",
  jira: "#0052CC",
  confluence: "#1868DB",
  slack: "#E01E5A",

  // Glow
  glowBlue: "rgba(134, 168, 231, 0.4)",
  glowPurple: "rgba(127, 90, 240, 0.4)",
} as const;

// === Fonts ===
export const FONTS = {
  heading: "Inter, SF Pro Display, system-ui, sans-serif",
  body: "Inter, SF Pro Text, system-ui, sans-serif",
  mono: "JetBrains Mono, SF Mono, Fira Code, monospace",
} as const;

// === Scene Timing (in frames at 30fps) ===
export const SCENE = {
  title: { start: 0, duration: 120 },        // 0-4s
  problem: { start: 120, duration: 180 },     // 4-10s
  architecture: { start: 300, duration: 360 }, // 10-22s
  ingestion: { start: 660, duration: 300 },    // 22-32s
  ragQuery: { start: 960, duration: 360 },     // 32-44s
  knowledgeGraph: { start: 1320, duration: 240 }, // 44-52s
  mcp: { start: 1560, duration: 120 },         // 52-56s
  outro: { start: 1680, duration: 120 },        // 56-60s
} as const;

export const TOTAL_DURATION = 1800; // 60 seconds @ 30fps
export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

// === Animation Presets ===
export const SPRING = {
  snappy: { damping: 200, mass: 0.5 },
  bouncy: { damping: 100, mass: 0.5 },
  gentle: { damping: 150, mass: 0.8 },
  slow: { damping: 120, mass: 1.2 },
} as const;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
